import { BaseStore } from "../stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import MutualAPI from "../api/mutual_api"

export type MutualProps = {
    key: string;
    identity: string;
    mutual_identity: string;
    mutual_status: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: MutualProps) => void;
};

// Domain object Mutual
export class Mutual implements MutualProps {
    key = "";
    identity = "";
    mutual_identity = "";
    mutual_status = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: MutualProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: MutualProps) {
        runInAction(() => {
            this.key = attributes.key;
            this.identity = attributes.identity;
            this.mutual_identity = attributes.mutual_identity;
            this.mutual_status = attributes.mutual_status;
            this.date_created = attributes.date_created;
            this.date_updated = attributes.date_updated;
        });
    }
}


export class MutualStore extends BaseStore<MutualProps, Mutual> {

    async fetchList(identityKey: string, cursor = "") {
        return MutualAPI.list(identityKey, cursor).then((resp) => {
            this.receiveUpdate(resp.items);
            if (resp.cursor) {
                this.fetchList(identityKey, resp.cursor);
            }
            return resp.items;
        })
    }


  async fetchListed(identityKey: string, cursor = "") {
        return MutualAPI.listed(identityKey, cursor).then((resp) => {
            this.receiveUpdate(resp.items);
            if (resp.cursor) {
                this.fetchListed(identityKey, resp.cursor);
            }
            return resp.items;
        })
  }

  async create(identityKey="", mutualIdentityKey="") {
        return MutualAPI.create(identityKey, mutualIdentityKey).then((resp) => {
            this.receiveUpdate(resp);
            return resp;
        })
  }

    async setMutualStatus(identityKey="", mutualIdentityKey="", status="") {
        return MutualAPI.setMutualStatus(identityKey, mutualIdentityKey, status).then((resp) => {
            this.receiveUpdate(resp);
            return resp;
        })
  }

  async remove(identityKey="", mutualIdentityKey="") {
      return MutualAPI.remove(identityKey, mutualIdentityKey).then((resp) => {
          this.items.splice(this.items.findIndex((i) => i.key === resp.key), 1);
        })
    }

    modelConstructor() {
        return Mutual;
    }

}
